{
  "el": {
    "todo_group": {
      "actions": {
        "create": "Εργασία",
        "update": "Επεξεργασία εργασίας"
      },
      "attributes": {
        "category": "Κατηγορία",
        "created_at": "Δημιουργήθηκε",
        "description": "Περιγραφή",
        "title": "Τίτλος",
        "todos_count": "Εργασίες",
        "units": "Ακίνητα"
      },
      "categories": {
        "confirmation": "Επιβεβαίωση",
        "upload": "Ανέβασμα"
      },
      "labels": {
        "no_groups": "Δεν υπάρχουν ακόμη εργασίες για αυτό το έργο.",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό"
      },
      "toasts": {
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
